import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import TickerBar from '@/pages/home/components/TickerBar';
import HeroGrid from '@/pages/home/components/HeroGrid';
import BigFeedGrid from '@/pages/home/components/BigFeedGrid';
import TimelineFeed from '@/pages/home/components/TimelineFeed';
import SixSplitSection from '@/pages/home/components/SixSplitSection';
import HotCommentsSection from '@/pages/home/components/HotCommentsSection';
import RankingSection from '@/pages/home/components/RankingSection';
import SubscribeSection from '@/pages/home/components/SubscribeSection';

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <TickerBar />
      <main className="w-full flex-1">
        <HeroGrid />
        <BigFeedGrid />
        <TimelineFeed />
        <SixSplitSection />
        <HotCommentsSection />
        <RankingSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
    </div>
  );
}